import { Component, OnInit, computed, Signal } from '@angular/core';
import { AppInitializerService, InitializationStatus } from '../../../services/app-initializer.service';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/authService/auth.service';
import { ErrorModalService } from 'src/app/services/error-modal-service/error-modal.service';

@Component({
  selector: 'app-app-loading',
  templateUrl: './app-loading.component.html',
  styleUrls: ['./app-loading.component.scss'],
})
export class AppLoadingComponent implements OnInit {
  initializationStatus: Signal<InitializationStatus>;
  initializationError: Signal<string | null>;
  currentLoadingStep: Signal<string>;
  isLoading: Signal<boolean>;
  hasError: Signal<boolean>;
  private readonly maxRetries = 3;
  private readonly retryCountKey = 'loginRetryCount';

  constructor(
    private appInitializer: AppInitializerService,
    private router: Router,
    private authService: AuthService,
    private errorModalService: ErrorModalService
  ) {
    this.initializationStatus = this.appInitializer.initializationStatus;
    this.initializationError = this.appInitializer.initializationError;
    this.currentLoadingStep = this.appInitializer.currentLoadingStep;
    this.isLoading = computed(() => this.initializationStatus() === 'loading');
    this.hasError = computed(() => this.initializationStatus() === 'error');
  }

  ngOnInit() {}

  private getRetryCount(): number {
    return parseInt(sessionStorage.getItem(this.retryCountKey) || '0', 10);
  }

  private setRetryCount(count: number): void {
    sessionStorage.setItem(this.retryCountKey, count.toString());
  }

  private resetRetryCount(): void {
    sessionStorage.removeItem(this.retryCountKey);
  }

  retryInitialization() {
    const retryCount = this.getRetryCount() + 1;
    this.setRetryCount(retryCount);
    if (retryCount >= this.maxRetries) {
      this.resetRetryCount();
      this.errorModalService.showLoginAttemptsError();
      return;
    }

    this.appInitializer.resetInitialization();
    this.authService.login().then((response) => {
      if (response) {
        this.resetRetryCount();
        this.router.navigate(['/']);
      }
    });
  }
}
